import { Routes, RouterModule } from '@angular/router';

const projectTaskExtRoutes: Routes = [
];

export const ProjectTaskRouter = RouterModule.forChild(projectTaskExtRoutes);